import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Box } from '@mui/material'
import TextFields from 'components/molecules/TextFields'
import PhoneNumberFields from 'components/molecules/PhoneNumberFields'
import CustomButton from 'components/atoms/CustomButton'
import CountrySelectFields from 'components/molecules/CountrySelectFields'
import {
  // ArrowLeftOutlined,
  ChevronLeft
} from '@mui/icons-material'
import {
  createCompany,
  getCountryList,
  getTiersList,
  validateFields,
} from 'api'
import { useDispatch, useSelector } from 'react-redux'
import { z } from 'zod'
import {
  showErrorMessage
  // showSuccessMessage
} from 'utils/showMessage'
import { adminCompanyActions } from 'store/reducers/admin/adminCompany'
import { useQuery } from 'react-query'
import { phoneNumberObject } from 'lib/schema'
import { checkCompanyPhoneNumber } from 'utils/checkPhoneNumber'
import { useTranslation } from 'react-i18next'
import SelectFields from 'components/molecules/SelectFields'
import { Card, Divider, InputNumber, Radio, Slider, Space, Switch } from 'antd'
// import SelectFields from 'components/molecules/SelectFields'
import EuroIcon from "@mui/icons-material/Euro";
import CircularProgress from '@mui/material/CircularProgress';
import { PAYMENT_TYPES, SUBSCRIPTION_TYPES, VALIDATE_FIELDS } from 'constant'
import { getValue } from '@testing-library/user-event/dist/utils'



const AddCompanyModal = ({ show, onClose, onSubmit }) => {
  const [tiers, setTiers] = useState([]);
  const [currentStep, setCurrentStep] = useState({
    step: 0,
    needValidate: false
  })
  const { t } = useTranslation()
  const token = useSelector((state) => state.admin.access_token)
  //const company = useSelector((state) => state.adminCompany)
  const dispatch = useDispatch()
  const [subscription_type, setSubscriptionType] = useState(SUBSCRIPTION_TYPES.MONTHLY);
  const [payment_type, setPayment_type] = useState(PAYMENT_TYPES.PLATFORM);
  const [custom, setCustom] = useState(false)

  const [loading, setLoading] = useState(false)

  const privateSteps = [
    {
      id: '1',
      name: t('Add Company'),
      optional: false,
      fields: ['user_type', 'admin_email', 'phone'],
      schema: z.object({
        user_type: z
          .string(),
        admin_email: z.string().email().min(1, { message: 'admin_email is required' }),
        phone: phoneNumberObject.refine((data) => data.nationalNumber !== '', {
          message: 'Telephone Number is required'
        })
      })
    },
    {
      id: '2',
      name: t('Company registry information'),
      optional: false,
      fields: [
        'name',
        'surname',
        'fiscal_code',
        'address',
        'municipality',
        'zip_code',
        'province',
        'country_id',
        'email'

      ],
      schema: z.object({
        name: z.string().min(1, { message: 'Name is required' }),
        surname: z.string().min(1, { message: 'Surname is required' }),
        fiscal_code: z
          .string()
          .regex(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/, {
            message: "Invalid fiscal code format",
          }),
        email: z.string().email().min(1, { message: 'email is required' }),
        country_id: z
          .object({
            id: z.number(),
            name: z.string()
          }),
        address: z.string().min(1, { message: 'address is required' }),
        municipality: z
          .string()
          .min(3, { message: 'Min value 3' })
          .max(50, { message: 'Max value 50' }),
        zip_code: z
          .string()
          .regex(/^[0-9]+$/i, { message: 'invalid input' })
          .min(5, { message: 'Min value 5' })
          .max(5, { message: 'Max value 5' }),
        province: z
          .string()
          .regex(/^[a-z]+$/i, { message: 'invalid input' })
          .min(2, { message: 'Min value 2' })
          .max(2, { message: 'Max value 2' }),
      })
    },
    {
      id: '3',
      name: custom ? t('Plans.CreateCustomPlan') : t('Plans.Set up subscription'),
      optional: false,
      fields: [
        'seat_number',
        'subscription_type',
        'set_as_payed',
        'is_custom',
        'price_for_custom'
      ],
      schema: z.object({

        seat_number: z.number().min(1, { message: 'seat_number is required' }),

        subscription_type: z
          .string(),
        set_as_payed:
          z.boolean(),
        is_custom: z.boolean(),
        price_for_custom: z.number()
      })
    },

  ]

  const companySteps = [
    {
      id: '1',
      name: t('Add Company'),
      optional: false,
      fields: ['user_type', 'admin_email', 'phone'],
      schema: z.object({
        user_type: z
          .string(),
        admin_email: z.string().email().min(1, { message: 'admin_email is required' }),
        phone: phoneNumberObject.refine((data) => data.nationalNumber !== '', {
          message: 'Telephone Number is required'
        })
      })
    },
    {
      id: '2',
      name: t('Company registry information'),
      optional: false,
      fields: [
        'company_name',
        'email',
        'sdi_receiver_code',
        'vat_number',
        'tax_code',
        'pec_address',
        'address',
        'municipality',
        'zip_code',
        'province',
        'country_id',
      ],
      schema: z.object({
        company_name: z.string().min(1, { message: 'Company name is required' }),
        email: z.string().email().min(1, { message: 'email is required' }),
        sdi_receiver_code: z
          .string()
          .regex(/^[a-z0-9]+$/i, { message: 'invalid input' })
          .min(7, { message: 'Min value 7' })
          .max(7, { message: 'Max value 7' }),
        vat_number: z
          .string()
          .regex(/^[a-z0-9]+$/i, { message: 'invalid input' })
          .min(8, { message: 'Min value 8' })
          .max(15, { message: 'Max value 15' }),
        tax_code: z
          .string()
          .regex(/^[a-z0-9]+$/i, { message: 'invalid input' })
          .min(6, { message: 'Min value 6' })
          .max(20, { message: 'Max value 20' }),
        pec_address: z.string().email().min(1, { message: 'pec_address is required' }),
        country_id: z
          .object({
            id: z.number(),
            name: z.string()
          }),
        address: z.string().min(1, { message: 'address is required' }),
        municipality: z
          .string()
          .min(3, { message: 'Min value 3' })
          .max(50, { message: 'Max value 50' }),
        zip_code: z
          .string()
          .regex(/^[0-9]+$/i, { message: 'invalid input' })
          .min(5, { message: 'Min value 5' })
          .max(5, { message: 'Max value 5' }),
        province: z
          .string()
          .regex(/^[a-z]+$/i, { message: 'invalid input' })
          .min(2, { message: 'Min value 2' })
          .max(2, { message: 'Max value 2' })
      })
    },
    {
      id: '3',
      name: custom ? t('Plans.CreateCustomPlan') : t('Plans.Set up subscription'),
      optional: false,
      fields: [
        'seat_number',
        'subscription_type',
        'set_as_payed',
        'is_custom',
        'price_for_custom'
      ],
      schema: z.object({
        seat_number: z.number().min(1, { message: 'seat_number is required' }),
        subscription_type: z
          .string(),
        set_as_payed:
          z.boolean(),
        is_custom: z.boolean(),
        price_for_custom: z.number()
      })
    },

  ]

  const { data } = useQuery({
    queryKey: ['countries-list'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getCountryList(token)
      return res
    }
  })

/*   const marks = {
    0: 'Small',
    4: 'Medium',
    8: 'Large',
    11: 'Custom'
  }; */

  const marks = {
    0: {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter', transform: 'translateX(-15%)'},
      label: 'Small'
    },
    4: {
      style: { fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter'},
      label: 'Medium'
    },
    8:  {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter'},
      label: 'Large'
    },
    11:  {
      style:  {fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter', transform: 'translateX(-90%)'},
      label: 'Custom'
    }
  };

  const companyDefaultValues = {
    user_type: "COMPANY",
    company_name: "",
    admin_email: "",
    email: "",
    phone: "",
    address: "",
    municipality: "",
    pec_address: "",
    province: "",
    sdi_receiver_code: "",
    tax_code: "",
    vat_number: "",
    zip_code: "",
    country_id: data?.resData?.data?.find(el => el?.id === 111),
    seat_number: 1,
    subscription_type: SUBSCRIPTION_TYPES.MONTHLY,
    set_as_payed: false,
    is_custom: false,
    price_for_custom: 0
  }

  const privateDefaultValues = {
    user_type: "PRIVATE",
    fiscal_code: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    address: "",
    municipality: "",
    province: "",
    zip_code: "",
    country_id: data?.resData?.data?.find(el => el?.id === 111),
    admin_email: "",
    seat_number: 1,
    subscription_type: SUBSCRIPTION_TYPES.MONTHLY,
    set_as_payed: false,
    is_custom: false,
    price_for_custom: 0
  }

  function calcIva(price, aliquota = 22) {
    return price * (aliquota / 100);
  }

  const [steps, setSteps] = useState(companySteps)
  const [values, setDefaultValues] = useState(companyDefaultValues)


  const resolver = zodResolver(steps[currentStep?.step]?.schema);

  const {
    handleSubmit,
    reset,
    trigger,
    setError,
    clearErrors,
    getValues,
    setValue,
    control,
    formState: { errors, isValid },
    watch,
  } = useForm({
    mode: 'onChange',
    resolver: resolver,
    defaultValues: values,
    values: values
  });

  const userType = watch('user_type');
  const sits = watch('seat_number');
  const is_custom = watch('is_custom');

  const selectedTier = tiers.find(
    (tier) => sits >= tier.min_seat && sits <= tier.max_seat
  );
  const maxSeats = tiers[tiers.length - 1]?.max_seat || 0;

  function closeModal() {
    reset()
    onClose()
    setCurrentStep({
      step: 0,
      needValidate: false
    })
  }

  const onAddCompany = async () => {

    setLoading(true)
    const phone = getValues('phone')
    const country = getValues('country_id')
    const sits = getValues('seat_number')

    setValue('phone', phone?.numberValue)
    setValue('country_id', country?.id)
    setValue('seat_number', parseInt(sits))

    try {

      const res = await createCompany(getValues(), token)

      if (res?.resData?.message === 'success') {
        setLoading(false)
        onSubmit()
        dispatch(adminCompanyActions.resetAll())
        closeModal()
      } else {
        setLoading(false)
        showErrorMessage(t('error messages.Internal server error'))
      }
    } catch (error) {
      setLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  }

  const onValidate1stStep = async (data) => {
    setLoading(true)
    const newData = checkCompanyPhoneNumber(data)

    const step1Validated = {
      //company_name: false,
      admin_email: false,
      phone: false
    }

    const handleValid = (key) => {
      setLoading(false)
      step1Validated[key] = true

      if (!step1Validated.admin_email || !step1Validated.phone) {
        return
      }

      dispatch(
        adminCompanyActions.setStep2({

          admin_email: newData?.admin_email,
          phone: newData?.phone
        })
      )
      setCurrentStep((curr) => {
        return {
          step: curr.step + 1,
          needValidate: false
        }
      })
    }

    const handleFail = (key) => {
      setLoading(false)
      step1Validated[key] = false

      dispatch(
        adminCompanyActions.setStep2({

          admin_email: data?.admin_email,
          phone: data?.phone
        })
      )
      setCurrentStep(() => {
        return {
          step: 0,
          needValidate: false
        }
      })
    }

    try {


      const res = await validateFields(token, { field_name: VALIDATE_FIELDS.email, value: newData?.admin_email })


      if (res?.resData?.data) {
        handleValid('admin_email')

      }
    } catch (error) {
      handleFail('admin_email')

      setError('admin_email', {
        type: 'manual',
        message: t('error email already exists!')
      })

      if (error?.response?.data?.errors[0]?.code === 1006) {
        showErrorMessage(t('error messages.Email already exists'))
      } else {
        showErrorMessage(t('error messages.Internal server error'))
      }

    }

    try {
      const res = await validateFields(token, { field_name: VALIDATE_FIELDS.phone, value: newData?.phone })

      if (res?.resData?.data) {
        handleValid('phone')

      }

    } catch (error) {
      handleFail('phone')

      setError('phone', {
        type: 'manual',
        message: t('error messages.CompanyPhone already exists!')
      })


      if (error?.response?.data?.errors[0]?.code === 1006) {
        showErrorMessage(t('error messages.CompanyPhone already exists!'))
      } else {
        showErrorMessage(t('error messages.Internal server error'))
      }

    }
  }

  const onValidate2stStep = async (data) => {
    setLoading(true)

    const step2Validated = {
      company_name: false,
      email: false,
      vat_number: false
    }

    const handleValid = (key) => {
      setLoading(false)

      step2Validated[key] = true

      if (userType === 'COMPANY' && (!step2Validated.company_name || !step2Validated.email || !step2Validated.vat_number)) {
        return
      }

      if (userType !== 'COMPANY' && !step2Validated.email) {
        return
      }

      setCurrentStep((curr) => {
        return {
          step: curr.step + 1,
          needValidate: false
        }
      })
    }

    const handleFail = (key) => {
      setLoading(false)
      step2Validated[key] = false


      setCurrentStep(() => {
        return {
          step: 1,
          needValidate: false
        }
      })
    }

    if (userType === 'COMPANY') {
      try {


        const res = await validateFields(token, { field_name: VALIDATE_FIELDS.company_name, value: data?.company_name })

        if (res?.resData?.data) {
          handleValid('company_name')
        }


      } catch (error) {

        showErrorMessage(t('error messages.Company name already exists!'))
        setError('company_name', {
          type: 'manual',
          message: t('error messages.Company name already exists!')
        })
        handleFail('company_name')

      }

      try {
        const res = await validateFields(token, { field_name: VALIDATE_FIELDS.company_email, value: data?.email })
        if (res?.resData?.data) {
          handleValid('email')

        }
      } catch (error) {


        handleFail('email')
        setError('email', {
          type: 'manual',
          message: t('error email already exists!')
        })


        if (error?.response?.data?.errors[0]?.code === 1006) {
          showErrorMessage(t('error messages.Email already exists'))
        } else {
          showErrorMessage(t('error messages.Internal server error'))
        }
      }

      try {
        const res = await validateFields(token, { field_name: VALIDATE_FIELDS.vat_number, value: data?.vat_number })
        if (res?.resData?.data) {
          handleValid('vat_number')

        }
      } catch (error) {


        handleFail('vat_number')
        setError('vat_number', {
          type: 'manual',
          message: t('error messages.Vat already exists')
        })


        if (error?.response?.data?.errors[0]?.code === 1006) {
          showErrorMessage(t('error messages.Vat already exists'))
        } else {
          showErrorMessage(t('error messages.Internal server error'))
        }
      }

    } else {
      try {

        const res = await validateFields(token, { field_name: VALIDATE_FIELDS.company_email, value: data?.email })


        if (res?.resData?.data) {
          handleValid('email')

        }
      } catch (error) {


        handleFail('email')
        setError('email', {
          type: 'manual',
          message: t('error email already exists!')
        })

        if (error?.response?.data?.errors[0]?.code === 1006) {
          showErrorMessage(t('error messages.Email already exists'))
        } else {
          showErrorMessage(t('error messages.Internal server error'))
        }
      }
    }

  }

  const onValidate3stStep = async () => {

    if (!sits || (is_custom && !getValues('price_for_custom'))) {
      setLoading(false)
      if (!sits) {
        setError('price_for_custom', { message: 'Required' })
        setCurrentStep((curr) => {
          return {
            step: 2,
            needValidate: true
          }
        })
      }

      if (is_custom && !getValues('price_for_custom')) {
        setLoading(false)
        setError('price_for_custom', { message: 'Required' })
        setCurrentStep((curr) => {
          return {
            step: 2,
            needValidate: true
          }
        })
      }

      return;
    }

    onAddCompany()

  }

  const next = async () => {

    const fields = steps[currentStep?.step].fields
    const output = await trigger(fields, { shouldFocus: true })


    if (!output) return

    if (currentStep?.step < steps.length) {
      /*  if (currentStep?.step === steps.length - 1) {
        
         return await handleSubmit(onAddCompany)()
       } */

      if (currentStep?.step === 0) {

        return await handleSubmit(onValidate1stStep)()
      }
      if (currentStep?.step === 1) {


        return await handleSubmit(onValidate2stStep)()
      }
      if (currentStep?.step === 2) {
        setLoading(true)
        return await handleSubmit(onValidate3stStep)()
      }


    }
  }

  const prev = () => {
    setValue('is_custom', false)
    setValue('price_for_custom', 0)
    if (currentStep?.step > 0) {
      setCurrentStep((curr) => {
        return {
          step: curr.step - 1,
          needValidate: true
        }
      })
    }
  }

  const onChangeSubType = async (e) => {
    setSubscriptionType(e.target.value);
    setValue('subscription_type', e.target.value)
    await trigger('subscription_type', { shouldFocus: true })
  };

  const onChangePaymentType = async (e) => {

    setPayment_type(e.target.value);
    setValue('set_as_payed', e.target.value)
    e.target.value === PAYMENT_TYPES.PLATFORM ? setValue('set_as_payed', false) : setValue('set_as_payed', true)
    await trigger('set_as_payed', { shouldFocus: true })
  };

  const handleChangePrice = async (val) => {
    setValue('price_for_custom', val)
    await trigger('subscription_type', { shouldFocus: true })
  };

  const handleChangeSeats = async (val) => {
    setValue('seat_number', val)
    await trigger('subscription_type', { shouldFocus: true })
  };

  const onSetIsCustom = (checked) => {
    setValue('is_custom', checked)
    checked ? setValue('price_for_custom', 1) : setValue('price_for_custom', 0)
  
  };

  useQuery({
    queryKey: ['tiers'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getTiersList()
      setTiers(res?.resData?.data?.sort((a, b) => a.id - b.id) || [])
    }
  })

  useEffect(() => {
    if (currentStep?.needValidate) {
      const fields = steps[currentStep?.step].fields
      trigger(fields, { shouldFocus: true })
    }
  }, [currentStep])

  useEffect(() => {
    userType === 'COMPANY' ? setSteps(companySteps) : setSteps(privateSteps);
    userType === 'COMPANY' ? setDefaultValues(companyDefaultValues) : setDefaultValues(privateDefaultValues);
  }, [userType])

  useEffect(() => {


    setCustom(is_custom)
  }, [is_custom])


  useEffect(()=>{
   
    if(sits > maxSeats ){
      setValue('is_custom', true)
      setValue('price_for_custom', 1)
    }
  },[sits])


  const monthlyPrice =
    is_custom ? getValues('price_for_custom') :
      subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? selectedTier?.price_per_seat_month : selectedTier?.price_per_seat_year
  const monthlyPricePerSits = monthlyPrice * sits
  const subTotal = subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? monthlyPricePerSits : (monthlyPricePerSits * 12)
  const total = calcIva(subTotal) + subTotal


  return (
    <ModalAdmin
      width={851}
      show={show}
      onClose={closeModal}
      title={
        <div className="flex flex-col">
          <span>{steps[currentStep?.step]?.name}</span>
          <div className="!font-thin !text-xs text-[#FFFFFF5C] flex justify-start items-center ">
            {currentStep?.step > 0 && (
              <div className="flex justify-start items-center -ml-2 cursor-pointer" onClick={prev}>
                <ChevronLeft />
              </div>
            )}{' '}
            STEP {currentStep?.step + 1} OF {steps.length}{' '}
            {steps[currentStep?.step]?.optional && '(optional)'}
          </div>

          {/* <p className='text-xs font-normal mt-2	text-[rgba(255,255,255,0.65)]	'>{t('Plans.Subscription cycle')}</p> */}

        </div>
      }>
      <Box
        noValidate
        component="form"


        className={`flex flex-col min-h-[466px] justify-between`}
      >

        {currentStep?.step === 0 && (
          <div className='grid grid-cols-2 gap-4' >
            <div className='mt-2'>
              <SelectFields
                theme="admin"
                control={control}
                label={t("Billing.UserType")}
                errors={errors}
                name="user_type"
                className={'h-[40px] mb-4'}
                options={[
                  { value: 'COMPANY', label: t('Billing.Company') },
                  { value: 'PRIVATE', label: t('Billing.PrivateUser') },

                ]}
              />
              <PhoneNumberFields

                control={control}
                theme="admin"
                label={t('Telephone Number')}
                placeholder={t('Telephone Number')}
                errors={errors}
                name={'phone'}
              />
            </div>
            <div className='mt-2'>
              <TextFields
                control={control}
                theme="admin"
                label={'Admin email'}
                errors={errors}
                name={'admin_email'}
              />
            </div>
          </div>
        )}

        {currentStep?.step === 1 && (
          <div className="grid grid-cols-2 gap-4">

            <div className='mt-2'>

              {
                userType === 'PRIVATE' && (
                  <>
                    <TextFields
                      control={control}
                      theme="admin"
                      label={t("Billing.Name")}
                      errors={errors}
                      name={'name'}
                    />
                    <TextFields
                      containerStyle='mt-4'
                      control={control}
                      theme="admin"
                      label={t("Billing.Surname")}
                      errors={errors}
                      name={'surname'}
                    />
                    <TextFields
                      containerStyle='mt-4'
                      control={control}
                      theme="admin"
                      label={t("Billing.CodiceFiscale")}
                      errors={errors}
                      name={'fiscal_code'}
                    />
                  </>
                )
              }
              {
                userType === 'COMPANY' && (
                  <>
                    <TextFields
                      control={control}
                      theme="admin"
                      label={t('Company Name')}
                      errors={errors}
                      name={'company_name'}
                    />


                    <TextFields
                      containerStyle='mt-4'
                      control={control}
                      theme="admin"
                      label={t("Billing.CodiceDestinatarioSDI")}
                      errors={errors}
                      name={'sdi_receiver_code'}
                    />


                    <TextFields
                      containerStyle='mt-4'
                      control={control}
                      theme="admin"
                      label={t('Tax Code')}
                      errors={errors}
                      name={'tax_code'}
                    />
                    <TextFields
                      containerStyle='mt-4'
                      control={control}
                      theme="admin"
                      label={t('PEC Address')}
                      errors={errors}
                      name={'pec_address'}
                    />
                  </>
                )
              }
              <TextFields
                containerStyle='mt-4'
                control={control}
                theme="admin"
                label={'Email'}
                errors={errors}
                name={'email'}
              />

            </div>


            <div className='mt-2'>

              {
                userType === 'COMPANY' &&
                (<TextFields
                  containerStyle='mb-4'
                  control={control}
                  theme="admin"
                  label={t('VAT Number')}
                  errors={errors}
                  name={'vat_number'}
                />)
              }


              <CountrySelectFields
                countries={data?.resData?.data ?? []}
                fromBE={true}
                control={control}
                theme="admin"
                label={t('Country')}
                errors={errors}
                name={'country_id'}

              />

              <TextFields
                containerStyle='mt-4'
                control={control}
                theme="admin"
                label={t('Address')}
                errors={errors}
                name={'address'}
              />
              <TextFields
                containerStyle='mt-4'
                control={control}
                theme="admin"
                label={t('Municipality')}
                errors={errors}
                name={'municipality'}
              />

              <div className="flex gap-4 mt-4">
                <TextFields
                  type="number"
                  control={control}
                  theme="admin"
                  label={t('ZIP CODE')}
                  errors={errors}
                  name={'zip_code'}
                />
                <TextFields
                  control={control}
                  theme="admin"
                  label={t('Province')}
                  errors={errors}
                  name={'province'}
                />
              </div>
            </div>






          </div>
        )}

        {currentStep?.step === 2 && (
          <div className="grid grid-cols-2 gap-4">

            <div className='mt-2 mr-2' style={{ borderRight: '1px solid rgba(255, 255, 255, 0.20)' }} >

           
              <div className='w-[300px]'>
                <p className='text-sm text-[#828282] font-normal mb-3'>{t("Plans.ActiveSits")}</p>

                <InputNumber
                  control={control}
                  min={1}
                  theme="admin"
                  errors={errors}
                  name={'seat_number'}
                  value={sits}
                  onChange={handleChangeSeats}
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.06)',
                    width: '100%',
                    borderRadius: "0px",
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                    marginTop: -12,
                    border: '0px',
                    outline: "none",
                    height: 38,
                    alignContent: 'center'
                  }}

                />

                <div>
                  <p className='text-sm text-[#828282] font-normal mt-4 mb-2'>{t("Plans.Billing cycle")}</p>

                  <Radio.Group control={control} onChange={onChangeSubType} value={subscription_type} className="admin-plan-radio">
                    <Space direction="vertical" className='w-full'>

                      <Radio value={SUBSCRIPTION_TYPES.MONTHLY} className='w-full'>
                        <p className='text-white text-sm font-semibold'>{t('Plans.Monthly')}</p>
                      </Radio>

                      <Radio value={SUBSCRIPTION_TYPES.YEARLY} className='w-full'>


                        <p className='text-white text-sm font-semibold'>{t('Plans.Yearly')}</p>




                      </Radio>

                    </Space>
                  </Radio.Group>
                </div>


                <div>
                  <p className='text-sm text-[#828282] font-normal mt-4 mb-2'>{t("Plans.CustomPrice")}</p>
                  <Switch
                  disabled={sits > maxSeats}
                    style={{ backgroundColor: is_custom && '#0049EE' }}
                    checked={is_custom} onChange={onSetIsCustom} />

                  {is_custom && (<>
                    <p className='text-sm text-[#828282] font-normal mt-4 mb-2'>{subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? t("Plans.MonthlyPrice") : t("Plans.YearlyPrice")}</p>

                    <InputNumber
                      min={1}
                      control={control}
                      theme="admin"
                      errors={errors}
                      name={'price_for_custom'}
                      suffix={<EuroIcon className="text-gray-500" />}
                      onChange={handleChangePrice}
                      defaultValue={getValues('price_for_custom')}
                      value={getValues('price_for_custom')}
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.06)',
                        width: '100%',
                        borderRadius: "0px",
                        borderTopLeftRadius: '4px',
                        borderTopRightRadius: '4px',
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                        border: '0px',
                        outline: "none",
                        height: 38,
                        alignContent: 'center'
                      }}

                    />

                    {errors.price_for_custom && (
                      <p className="text-red-500 text-xs mt-1">{errors?.price_for_custom?.message}</p>
                    )}
                  </>)}

                </div>


                <p className='text-sm text-[#828282] font-normal mt-4 mb-2'>{t("Plans.PlanPaymentMethod")}</p>

                <Radio.Group control={control} onChange={onChangePaymentType} value={payment_type} className="admin-plan-radio">
                  <Space direction="vertical" className='w-full'>

                    <Radio value={'PLATFORM'} className='w-full'>
                      <p className='text-white text-sm font-semibold'>{t('Plans.inPlatform')}</p>

                    </Radio>

                    <Radio value={'EXTERNAL'} className='w-full'>

                      <p className='text-white text-sm font-semibold'>{t('Plans.Externally')}</p>

                    </Radio>

                  </Space>
                </Radio.Group>
              </div>

            </div>



            <div className="mt-2">

              <Card
                className={`card-add-company rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none`} hoverable>

                <div className='flex justify-between '>
                  <p className='text-white text-[13px] font-semibold'>{t('Plans.New plan').toUpperCase()}</p>
                  <p className='font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]'>
                    €{parseFloat(monthlyPrice).toFixed(2)}
                    <span className='text-[rgba(255, 255, 255, 0.70)]'> /{t("Plans.Month")}/user </span> </p>
                </div>

                <div className='flex justify-between mt-1'>
                  <p className='text-white text-[13px] font-semibold'>{t("Plans.Sits")} ({sits})</p>
                  <p className='font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]' >
                    €{parseFloat(monthlyPricePerSits).toFixed(2)}
                    <span className='text-[rgba(255, 255, 255, 0.70)]'> /{t("Plans.Month")} </span> </p>
                </div>

                <div className='flex justify-between  mt-1'>
                  <p className='text-white text-[13px] font-semibold'>{t("Plans.Billing")}</p>
                  <p className='font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]'> {subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? t('Plans.Monthly') : t('Plans.Yearly')}</p>
                </div>

                <div className='flex justify-between  mt-1'>
                  <p className='text-white text-[13px] font-semibold'>{t("Plans.Payment")}</p>
                  <p className='font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]'> {payment_type === PAYMENT_TYPES.PLATFORM ? t('Plans.inPlatform') : t('Plans.Externally')}</p>
                </div>

                <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.20)', marginTop: "12px", marginBottom: "12px" }} />

                <p className='text-white text-[13px] font-semibold'>{t("Plans.Discount tier")}</p>

                <Slider
                  className='admin-slider'
                  min={0}
                  max={maxSeats + 1}
                  marks={marks}
                  defaultValue={Math.min(sits, maxSeats + 1)}
                  value={Math.min(sits, maxSeats + 1)}
                  disabled
                  tooltip={{ open: false }}
                  dotStyle={{ backgroundColor: '#94B1F4', width: '10px', height: '10px', marginTop: "-1px" }}
                  activeDotStyle={{ backgroundColor: '#0049EE', width: '10px', height: '10px', marginTop: "-1px" }}
                  styles={{
                    rail: { height: 4, },
                    tracks: { backgroundColor: "#0049EE", height: 4, },
                  }}
                />

              </Card>

              <div className='mt-4'>
                <div className='flex justify-between'>
                  <p className='text-xs font-normal text-[rgba(255, 255, 255, 0.65)]'>Sub {t("Plans.Total")}</p>
                  <p className='text-xs font-normal text-[rgba(255, 255, 255, 0.65)]'>

                    {parseFloat(subTotal).toFixed(2)}
                    €</p>
                </div>

                <div className='flex justify-between mt-2'>
                  <p className='text-xs font-normal text-[rgba(255, 255, 255, 0.65)]'>{t('Plans.VAT')}</p>
                  <p className='text-xs font-normal text-[rgba(255, 255, 255, 0.65)]'>{parseFloat(calcIva(subTotal)).toFixed(2)}€</p>
                </div>
                <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.20)' }} />

                <div className='flex justify-between mt-2'>
                  <p className='text-sm font-semibold text-white'>{t("Plans.Total")} ({t(subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? 'Plans.Monthly' : 'Plans.Yearly')})</p>
                  <p className='text-sm font-semibold text-white'>
                    {parseFloat(total).toFixed(2)} €
                  </p>
                </div>

              </div>



            </div>


          </div>
        )}


        <div className={`flex gap-2 justify-end mt-8`}>
          <div className="w-[50%] flex justify-between gap-2">
            <CustomButton
              buttonStyle={{
                width: '100%',
              }}
              buttonColor="secondary" onClick={closeModal}>
              {t('Cancel')}
            </CustomButton>
            <CustomButton
              buttonStyle={{
                width: '100%',
              }}
              onClick={next}
              disabled={!isValid || loading}
            >
              {currentStep?.step < steps.length - 1 ? t('Continue') : t('Confirm')}
              {loading && (<CircularProgress size="15px" style={{ marginLeft: 8, color: 'white' }} />)}
            </CustomButton>
          </div>
        </div>


      </Box>
    </ModalAdmin>
  )
}

export default AddCompanyModal
